import {IconButton} from '@mui/material';
import muiStyled from '@mui/material/styles/styled';

const ToolbarIconButton = muiStyled(IconButton)(({theme}) => ({
  width: 20,
  height: 20,
  backgroundColor: theme.palette.common.white,
  color: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: '#dedede'
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.common.white,
    opacity: 0.7
  },
  marginRight: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    marginRight: theme.spacing(0.5)
  }
}));

export default ToolbarIconButton;
